/**
 * Loading component
 */

// React
import React from 'react';

// Libraries
import { useRecoilValue } from 'recoil';

// MUI Components
import Backdrop from '@mui/material/Backdrop';
import { CircularProgress } from '@mui/material';

// Recoil
import { loadingAtom } from 'recoil/LoadingRecoil';

// Component
const Loading: React.FC = () => {
  const loading = useRecoilValue(loadingAtom);

  return (
    <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loading;
